import React from 'react';
import ActionsMenu, {
    ActionsMenuProps,
} from '../../common/Navigation/ActionsMenu';
import CcScheduleReport from '../../services/models/CcScheduleReport';

import OperationalReportScheduleDeleteButton from './OperationalReportScheduleDeleteButton';
import OperationalReportCreateScheduleReportButton from './OperationalReportCreateScheduleReportButton';
import CcReport from '../../services/models/CcReport';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

export default OperationalReportScheduleActionMenu;

export type OperationalReportScheduleActionMenuProps = ActionsMenuProps & {
    schedule: CcScheduleReport;
    templates?: CcReport[];
};

function OperationalReportScheduleActionMenu({
    schedule,
    templates,
    onActionPerformed,
}: OperationalReportScheduleActionMenuProps) {
    return (
        <ActionsMenu
            items={[
                {
                    key: 'edit',
                    icon: <EditOutlined />,
                    label: (
                        <OperationalReportCreateScheduleReportButton
                            schedule={schedule}
                            templates={templates}
                            onSuccess={onActionPerformed}
                        />
                    ),
                },
                {
                    key: 'delete',
                    waitForConfirm: true,
                    critical: true,
                    icon: <DeleteOutlined />,
                    label: (
                        <OperationalReportScheduleDeleteButton
                            schedule={schedule}
                            onSuccess={onActionPerformed}
                        ></OperationalReportScheduleDeleteButton>
                    ),
                },
            ]}
        />
    );
}
